import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  centerBox: {
    marginTop: 10,
    alignItems: 'center',
  },
  shopperName: {
    marginBottom: 5,
    textAlign: 'center',
  },
  infoText: {
    width: '90%',
    textAlign: 'center',
    marginBottom: 10,
  },
  buttonContainer: {
    width: '87%',
    gap: 10,
    marginTop: 10,
  },
});
